import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { authService } from '../../services/auth/auth.service';
import { WorkosSessionService } from '../../services/auth/workos-session.service';

/**
 * Shown on every screen while Colobbo support is signed in as someone (WorkOS impersonation,
 * COL-773): a coloured frame around the whole window, the way WorkOS recommends, and a panel
 * saying who is really signed in, as whom, until when, with "End session".
 *
 * Nothing is shown otherwise. The API is the real guard (it records every change and refuses the
 * high-risk ones); this makes sure support, and anyone looking at the screen, can't miss it.
 */
@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrl: './impersonation-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonationBannerComponent {
  private readonly auth = inject(authService);
  readonly support = inject(WorkosSessionService).supportSession;

  /** "2:45 pm" in the viewer's own clock. */
  endsAtText(endsAt: number): string {
    return new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(endsAt);
  }

  /** Ends support's session only (the API never touches the person's own sign-ins). */
  endSession(): void {
    this.auth.signOut('company');
  }
}
